import React, { Component } from "react";
import { withStyles, createStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import {
  Button,
  Dialog,
  Grid,
  IconButton,
  Theme,
  Tooltip,
  Typography,
  WithStyles,
} from "@material-ui/core";
import { CloseOutlined as CloseIcon } from "@material-ui/icons";
import { makeStyles } from "@material-ui/styles";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from "lodash";
import moment from 'moment';

// helper
import { courseByid } from "../mock/courseById";
import dateService from "../../../common/services/dateService";
import { getFormatedDate } from '../treeComponents/helper';


//style
import { ViewPhaseStyles } from "../../styles";
import { styles } from "../../styles/ViewPhaseStyles";

// component
import CourseFooter from './createCoursePlan/CourseFooter';
import CombinedPhases  from '../treeComponents/CombinedPhases';
import CoursePlanLandingPage from "../../containers/coursePlanLandingPage";

// services
import courseManagementServices from '../../../course-Management/service/courseManagementServices';

// action
import {contentManagementAction} from '../../reducers/contentMangementData';
import DialogLarge from "../../../content-request/common/DialogLarge";

interface ViewPhaseProps extends WithStyles<typeof ViewPhaseStyles> {
  userTreeDetails:any,
  coursePlanId :string,
  isShowButton: boolean,
  setViewPlanData: Function,
  viewPlanData: any,
  history: any,
  match:any,
  handleOnSelect?: Function
  content: any,
}

interface ViewPhaseState {
  name: any;
  timeLine: any;
  isRevision: any;
  isClose: boolean,
  isShowSelect: boolean,
  sub: any,
  courseId:string,
  courseDetailObj: any,

}

class ViewPhase extends Component<ViewPhaseProps, ViewPhaseState> {
  constructor(props: ViewPhaseProps) {
    super(props);
    this.state={
      name: '',
      timeLine: '',
      isRevision: '',
      isShowSelect: false,
      isClose: true,
      sub: [],
      courseId:"",
      courseDetailObj: {},
    }
  }

  componentWillMount = () => {
    const { setViewPlanData,coursePlanId} = this.props;
    //console.log('666', coursePlanId)
    courseManagementServices.getCousePlanApiById(coursePlanId).then(({ coursePlan }) => {
      setViewPlanData({
        viewPlanData: { ...coursePlan }
      })
    })
    const { match: { params: { id = '' } } } = this.props;
    this.setState({courseId:id});

    courseManagementServices.getPackageById(id).then((response: any) => {
      const { courseDetails = [] } = response.responseObject.packageData;
      let courseId = courseDetails[0].courseId;

      courseManagementServices.getCourseDetails(courseId).then(( res )=> {
        this.setState({courseDetailObj:res});
      })

    })
    
  }

  setIsRevisionValue = (value: any) => {
    if (value === true) {
      return "Yes";
    } else {
      return "No";
    }
  };

  createPhase = (
    name: any,
    timeLine: any,
    isRevision: any,
    subjects:any,
  ) => {
    return { name, timeLine, isRevision,subjects };
  };

  getSubjectCount(subCount: any) {
    let res: any = [];
    if (subCount.length) {
      subCount.forEach((subject: any) =>
        res.push(
          <TableCell
            // onBlur={undefined}
            // title={subject.chapterCount}
            key={subject.chapterCount}
          >
            {subject.chapterCount}
          </TableCell>
        )
      );
      return res;
    }
  }
  getCoursesSubject(subName: any) {
    let res: any = [];
    if (subName.length) {
      subName.forEach((subject: any) =>
        res.push(
          <Tooltip title={subject.name} placement='top' PopperProps={{
            popperOptions: {
              modifiers: {
                offset: {
                  enabled: true,
                  offset: '-25px, -25px',
                },
              },
            },
          }}>
            <TableCell key={subject.name.substring(0, 2).toUpperCase()} style={{cursor: 'pointer'}}>
              {subject.name.substring(0, 2).toUpperCase()}
            </TableCell>
          </Tooltip>
        )
      );
      return res;
    }
  }

  renderCourseList = () => {
    const { history } = this.props;
    const {courseId} = this.state;
    history.push(`/course-Management/create-standard-course/${courseId}`)
  }

  handleClose = () => {
    const { history } = this.props;
    const {courseId} = this.state;
    this.setState({
      isClose: false,
    });
    history.push(`/course-Management/create-standard-course/${courseId}`)
  };

  handleSelectCoursePlan=()=> {
    this.setState({isShowSelect:true})
  }

  renderTargetExamDates = () => {
    const { examDates } = this.state.courseDetailObj;
    if (examDates) {
      let count: any = examDates.length;
      //console.log({examDates});
      return (
        examDates && examDates.map((targetDate: any, index: any) =>

          <span>{getFormatedDate(targetDate.startDate).join(" ")}-{getFormatedDate(targetDate.endDate).join(" ")}{(count) === 1 ? '' : index === count - 1 && count > 0 ? '' : ','}&nbsp;</span>

        )
      )

    }
  }
  getDataForCoursePlan = () => {
      const { coursePlanId, content=[] } = this.props;
     const courseData =  content && content.length && content.filter((course: any) => course.coursePlanId._id === coursePlanId)
     return courseData && courseData[0];
  }

  render() 
  
  {
  
    const { classes, userTreeDetails,coursePlanId, viewPlanData, handleOnSelect, content = [], match  } = this.props;
    const {courseDetailObj} = this.state;
    const { name, startDate:courseStartDate, endDate:courseEndDate } =courseDetailObj;
    let start: any = moment(courseStartDate).format("DD");
    let end: any = moment(courseEndDate).format("DD-MMM-YYYY");

    let phasesArr:any = [];
    let subjectsArr:any = [];
    let phaseTotalCount:number = 0;
    let weekWiseSubject: any =[];

    if (viewPlanData) {
      const { phases = [], totalPhases = 0, subjects = []} = viewPlanData;
      const { subject: weekWiseSubject }=phases;
         phasesArr=phases;
      subjectsArr =subjects;
      phaseTotalCount = totalPhases;
    }

    let totalChapterCount = 0;
    let startDate;
    let endDate;
    let isRevision;

    let coursePlanStartDate = viewPlanData.startDate;
    let coursePlanEndDate = viewPlanData.endDate;

    const subjectCounts = phasesArr.map((phase: any) => {
      startDate = phase.startDate;
      endDate = phase.endDate;
      isRevision = this.setIsRevisionValue(phase.isRevision);
      phase.subjects.map((subject: any) => {
        totalChapterCount = totalChapterCount + subject.chapterCount;
      });
    });

    const dataCourse: any = this.getDataForCoursePlan();
    //console.log({dataCourse});
    let rows: any=[];
    phasesArr && phasesArr.length && phasesArr.map((items: any) => {

      rows.push(this.createPhase(`${items.name}`,`${dateService.dateOnly(items.startDate)} - ${dateService.dateOnly(items.endDate)}`, items.isRevision,items.subjects))
    })
    return (
      <>
        {this.state.isShowSelect && this.renderCourseList()}
        {!this.state.isShowSelect && (
          <Grid className={classes.viewPhasePlan}>
            <Grid container justify="space-between">
              <Grid item style={{ marginTop: 10 }}>
                <Typography component="h5" variant="h6" className={classes.MainHeading}>
                  View Phase Plan
                </Typography>
              </Grid>
              <Grid item alignItems="flex-end">
                <IconButton onClick={this.handleClose}>
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={10}>
                <Typography component="subheading" gutterBottom className={classes.courseDuration}>
                  {" "}
                  Course Duration:
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography component="subheading" gutterBottom className={classes.countPhase}>
                  {" "}
                  No. of Phase(s)
                </Typography>
              </Grid>
              {/* </Grid>
        <Grid container> */}
              <Grid item xs={10}>
                <Typography component="subheading" gutterBottom className={classes.countPhase}>
                  {dateService.dateOnly(coursePlanStartDate)} to{" "}
                  {dateService.dateOnly(coursePlanEndDate)}{" "}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography component="subheading" gutterBottom>
                  {" "}
                  {phaseTotalCount}{" "}
                </Typography>
              </Grid>
            </Grid>
            <Grid item>
              <Typography component="subheading" gutterBottom className={classes.countPhase}>
                <p>
                Total  {totalChapterCount}  chapters need to be divided into {phaseTotalCount} phase(s)
                </p>
              </Typography>
            </Grid>

            <Table className={classes.tableWrapper}>
              <TableHead>
                <TableRow>
                  <TableCell>Phase Names</TableCell>
                  {this.getCoursesSubject(subjectsArr)}

                  <TableCell align="left">Time Line</TableCell>
                  <TableCell align="center">Is Revision?</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row: any) => (
                  <TableRow key={row.name}>
                    <TableCell component="th" scope="row" align="left">
                      {row.name}
                    </TableCell>
                    {this.getSubjectCount(row.subjects)}
                    <TableCell align="left">{row.timeLine}</TableCell>
                    <TableCell align="center">
                      {row.isRevision ? "Yes" : "No"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>

            <Grid className={classes.phaseFooterFixed}>
              <DialogLarge
                headerTitle=""
                isShowHeader={false}
                isFooter
                footerCTAName="Select Course Plan"
                // onJobDone={() => this.handleSelectCoursePlan()}
                onJobDone = {() =>
                  handleOnSelect && handleOnSelect(dataCourse)
                }
                isJobDoneDisabled={""}
                htmlElements={
                  <Grid className={classes.examContainer}>
                    <Typography>
                      <img src="/assets/svg/goalNav1.svg" color="primary" />
                      &nbsp;Target Exam Date
                    </Typography>

                    <Typography className={classes.examDate}>
                      &nbsp;{name}-{this.renderTargetExamDates()}
                    </Typography>
                  </Grid>
                }
              />
              {/* )} */}
            </Grid>
          </Grid>
        )}
      </>
    );
  }
}
const mapStateToProps = (state: any) => ({
  viewPlanData: _.get(state, "courseMangementData.contentManagementData.viewPlanData", {}),
  });

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      setViewPlanData: contentManagementAction.setViewPlanData,
    },
    dispatch
  );


// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ViewPhase));
